"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CodeIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
}, props));
CodeIcon.displayName = 'CodeIcon';
var _default = exports.default = CodeIcon;